import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle.svg'
import _imports_2 from '@/app/ui/assets/svg/logo-lion.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-253fec04")

_pushScopeId("data-v-253fec04")
const _hoisted_1 = {
  key: 3,
  class: "pl-4 md:pl-8 pt-4 md:pt-8 flex flex-col"
}
const _hoisted_2 = {
  key: 5,
  class: "pr-4 md:pr-8 pt-4 md:pt-8 flex flex-col"
}
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center w-full mt-2"
}
const _hoisted_4 = { class: "flex flex-col space-y-1" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row space-x-2 items-center"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "ok"
}, null, -1)
const _hoisted_7 = { class: "text-12px text-black-lp-300" }
const _hoisted_8 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "x"
}, null, -1)
const _hoisted_10 = { class: "text-12px text-black-lp-300" }
const _hoisted_11 = {
  key: 9,
  class: "absolute bottom-0"
}
const _hoisted_12 = {
  class: "relative flex overflow-x-hidden bg-black",
  style: {"z-index":"99999999999"}
}
const _hoisted_13 = { class: "text-white marquee-text pr-2 font-semibold" }
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "marquee-lion-logo",
  src: _imports_2,
  alt: "up"
}, null, -1)
const _hoisted_15 = { class: "text-white pr-2 marquee-text font-semibold" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "marquee-lion-logo",
  src: _imports_2,
  alt: "up"
}, null, -1)
const _hoisted_17 = { class: "flex flex-col items-center space-y-6 max-w-sm" }
const _hoisted_18 = { class: "text-14px text-black-lp-300 font-semibold items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_watermark_page = _resolveComponent("watermark-page")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SidebarV2 = _resolveComponent("SidebarV2")!
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_loading = _resolveComponent("loading")!
  const _component_ToastLoginApproval = _resolveComponent("ToastLoginApproval")!
  const _component_ToastSuccessV2 = _resolveComponent("ToastSuccessV2")!
  const _component_ToastSuccessAnnouncement = _resolveComponent("ToastSuccessAnnouncement")!
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_MultipleSnackbar = _resolveComponent("MultipleSnackbar")!
  const _component_AccountAlertContainer = _resolveComponent("AccountAlertContainer")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Banner = _resolveComponent("Banner")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_watermark_page, { key: _ctx.rerenderWatermark }),
    _createVNode("div", {
      class: ["flex flex-col font-montserrat overflow-hidden h-screen relative", 
      `${
        _ctx.getCurrentRoute.meta.isMobileMode
          ? 'rensponsive-mobile-mode'
          : 'md:flex-row'
      }`
    ]
    }, [
      _withDirectives(_createVNode("div", {
        class: ["w-full flex justify-between border-b px-4 py-2 bg-white", `${_ctx.getCurrentRoute.meta.isMobileMode ? '' : 'md:hidden'} ${_ctx.isSidebarAndBreadcrumbV2 ? 'pl-21 md:px-4' : ''}`]
      }, [
        _createVNode(_component_Icons, {
          name: "bars",
          class: "w-5 text-gray-lp-800",
          onClick: _ctx.openCollapseSidebar
        }, null, 8, ["onClick"]),
        _createVNode("img", {
          src: require('@/app/ui/assets/svg/logo-genesis-with-text.svg'),
          class: "w-24 cursor-pointer hidden",
          alt: "logo",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toDashboard && _ctx.toDashboard(...args)))
        }, null, 8, ["src"])
      ], 2), [
        [_vShow, !_ctx.isSidebarAndBreadcrumbV2]
      ]),
      (_ctx.isSidebarAndBreadcrumbV2)
        ? (_openBlock(), _createBlock(_component_SidebarV2, { key: 0 }))
        : (_openBlock(), _createBlock(_component_sidebar, { key: 1 })),
      (!_ctx.getCurrentRoute.meta.isFreeze)
        ? (_openBlock(), _createBlock("div", {
            key: 2,
            id: "layout-wrapper",
            class: 
        `${
          _ctx.isSidebarAndBreadcrumbV2 && !_ctx.noPaddingWithBreadcrumbV2
            ? 'pl-21 md:px-4 pt-4'
            : _ctx.getCurrentRoute.name === 'dashboard'
            ? 'px-8 pt-4'
            : _ctx.getCurrentRoute.name === 'detail-send-and-win' || _ctx.layoutNoPadding
            ? 'px-0 pt-0'
            : _ctx.newLayoutDesign
            ? 'px-0 pt-4'
            : 'px-8 pt-4'
        } flex flex-col w-full overflow-hidden relative ${
          _ctx.isShowRunningText ? 'pb-4' : ''
        }`
      
          }, [
            (_ctx.$route.meta.header)
              ? (_openBlock(), _createBlock(_component_Breadcrumb, {
                  key: 0,
                  class: 
          `${
            _ctx.isMobile && _ctx.isSidebarAndBreadcrumbV2
              ? 'pr-4'
              : _ctx.newLayoutDesign
              ? 'px-8'
              : _ctx.noPaddingWithBreadcrumbV2 ? 'pl-21 md:px-4 pt-4' : ''
          }`
        
                }, null, 8, ["class"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_view)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.getCurrentRoute.meta.isFreeze)
        ? (_openBlock(), _createBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      (_ctx.getCurrentRoute.meta.isFreeze)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 4 }))
        : _createCommentVNode("", true),
      (_ctx.getCurrentRoute.meta.isFreeze)
        ? (_openBlock(), _createBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.errorModal)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 6,
            textCancel: _ctx.errorTextCancel,
            onClose: _ctx.closeErrorModal,
            onSubmit: _ctx.errorOnSubmit,
            textSuccess: _ctx.errorTextSuccess,
            title: _ctx.$t(_ctx.errorEntities.title),
            message: _ctx.$t(_ctx.errorEntities.message),
            image: _ctx.errorEntities.image
          }, null, 8, ["textCancel", "onClose", "onSubmit", "textSuccess", "title", "message", "image"]))
        : _createCommentVNode("", true),
      (_ctx.messageModal)
        ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 7 }, _ctx.messageEntities), {
            custom: _withId(() => [
              (_ctx.messageEntities.totalFailed)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      (_ctx.messageEntities.totalSuccess)
                        ? (_openBlock(), _createBlock("div", _hoisted_5, [
                            _hoisted_6,
                            _createVNode("div", _hoisted_7, _toDisplayString(!!_ctx.messageEntities.customTotalSuccess
                    ? _ctx.messageEntities.customTotalSuccess
                    : _ctx.messageEntities.isBulkUpload
                    ? `Total Sukses ${_ctx.messageEntities.totalSuccess}`
                    : `${_ctx.messageEntities.totalSuccess} No. STT Sukses`), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode("div", _hoisted_10, _toDisplayString(!!_ctx.messageEntities.customTotalFailed
                    ? _ctx.messageEntities.customTotalFailed
                    : _ctx.messageEntities.isBulkUpload
                    ? `Total Gagal ${_ctx.messageEntities.totalFailed}`
                    : `${_ctx.messageEntities.totalFailed} No. STT Gagal`), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 16))
        : _createCommentVNode("", true),
      _createVNode(_component_loading, {
        modelValue: _ctx.loadingModal,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadingModal = $event)),
        message: _ctx.loadingMessage
      }, null, 8, ["modelValue", "message"]),
      _createVNode(_component_Snackbar, {
        key: _ctx.snackbarRerender,
        "model-value": _ctx.snackbar,
        "onUpdate:modelValue": _ctx.toggleSnackbar,
        iconLeft: _ctx.snackBarIconLeft,
        message: _ctx.snackbarMessage,
        "is-positive": _ctx.snackbarPositive,
        timeout: _ctx.snackbarTimeout,
        autoClose: _ctx.snackbarAutoClose,
        snackbarBackgroundColor: _ctx.snackbarBackgroundColor
      }, {
        default: _withId(() => [
          (_ctx.snackbarData.type === 'login-approval')
            ? (_openBlock(), _createBlock(_component_ToastLoginApproval, { key: 0 }))
            : (_ctx.snackbarData.type === 'success')
              ? (_openBlock(), _createBlock(_component_ToastSuccessV2, { key: 1 }))
              : (_ctx.snackbarData.type === 'announcement')
                ? (_openBlock(), _createBlock(_component_ToastSuccessAnnouncement, { key: 2 }))
                : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model-value", "onUpdate:modelValue", "iconLeft", "message", "is-positive", "timeout", "autoClose", "snackbarBackgroundColor"]),
      (
        _ctx.isShowBalanceNotification ||
          _ctx.isShowCargoNotification ||
          _ctx.isShowBulkBookingNotif
      )
        ? (_openBlock(), _createBlock(_component_MultipleSnackbar, {
            key: 8,
            title: _ctx.detailMultipleSnackBar.title,
            isClickable: _ctx.detailMultipleSnackBar.isClickable,
            isEditable: _ctx.detailMultipleSnackBar.isEditable
          }, null, 8, ["title", "isClickable", "isEditable"]))
        : _createCommentVNode("", true),
      _createVNode(_component_AccountAlertContainer, {
        alerts: _ctx.accountAlerts,
        onClose: _ctx.onCloseAccountAlert
      }, null, 8, ["alerts", "onClose"]),
      (_ctx.textArray.length)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", {
                class: "flex animate-marquee whitespace-nowrap marquee-container",
                style: { animationDuration: _ctx.totalTimeRunningText }
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.textArray, (text, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: `text-${index}`,
                    class: "flex items-center mr-6"
                  }, [
                    _createVNode("p", _hoisted_13, _toDisplayString(text), 1),
                    _hoisted_14
                  ]))
                }), 128))
              ], 4),
              _createVNode("div", {
                class: "flex absolute animate-marquee2 whitespace-nowrap marquee-container",
                style: { animationDuration: _ctx.totalTimeRunningText }
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.textArray, (text, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: `text-duplicate-${index}`,
                    class: "flex items-center mr-6"
                  }, [
                    _createVNode("p", _hoisted_15, _toDisplayString(text), 1),
                    _hoisted_16
                  ]))
                }), 128))
              ], 4)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Dialog, {
        modelValue: _ctx.responseModal,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.responseModal = $event)),
        header: false,
        persistent: "",
        onReset: _ctx.setCloseResponseModal
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_Icons, {
              name: _ctx.errorEntities.isSuccess ? 'badge-success' : 'badge-failed',
              class: "w-36"
            }, null, 8, ["name"]),
            _createVNode("span", _hoisted_18, _toDisplayString(_ctx.errorEntities.message), 1),
            _createVNode(_component_LpButton, {
              onClick: _ctx.setConfirmResponseModal,
              customClass: "px-10 py-2",
              textColor: "white",
              title: "OK",
              class: "mt-10"
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onReset"])
    ], 2),
    _createVNode(_component_Banner)
  ], 64))
})